<template>
      <div>

      </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    name: 'transfer',
    data(){
      return{
        membersign:'',
        referer:''
      }
    },
    created(){
      var self=this;
      var urlparam = self.$route.query;
      self.membersign = urlparam.membersign;
    },
    mounted(){
      this.gettoken();
    },
    methods:{
      gettoken:function(){
        var self = this;
        axios.post('/v1/user/token/get', qs.stringify({
          member_sign:self.membersign
        }))
          .then(function (res) {
            var bastoToken = res.data.token;
            sessionStorage.setItem('bastoToken',bastoToken);
            self.$store.state.isnew=res.data.is_new;
            self.$store.state.islogin=res.data.is_new;
            self.$store.state.referer=res.data.referer;
            if(res.data.referer == ''){
              self.referer = "/"
            }else{
              self.referer = res.data.referer
            }
            //去掉地址中的时间戳
            // alert('location.href=to == ' + `${location.protocol+'//'+location.host+'/#'+self.referer}`)
            location.href=location.protocol+'//'+location.host+'/#'+self.referer;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getuserinfo:function(){
        const self = this;
        axios.post('/v1/user/clear')
          .then(function(res){
            console.log(res.data)
            if(res.data.result=='success'){
              location.href=location.protocol+'//'+location.host+'/#'+self.referer;
            }
          })
          .catch(function(error){
            console.log(error);
          });

      }
    },
    watch:{
      referer:function(){
        //this.getuserinfo();
      }
    }

  }
</script>





// WEBPACK FOOTER //
// src/components/common/transfer.vue